/** Brand mark — synced from `frontend/assets/icon.png` into `public/brand-logo.png` on build */
export function BrandLogo({
  className = '',
  heightClass = 'h-8 sm:h-9',
  variant = 'header',
}: {
  className?: string;
  /** Shorthand for consistent header sizing */
  heightClass?: string;
  variant?: 'header' | 'hero';
}) {
  const classes =
    variant === 'hero'
      ? `h-auto w-full max-w-[180px] object-contain rounded-[22%] sm:max-w-[220px] ${className}`
      : `aspect-square w-auto max-w-none object-contain object-left rounded-[22%] ${heightClass} ${className}`;

  return (
    <img
      src="/brand-logo.png"
      alt="Peak Performance IQ"
      className={classes}
      width={variant === 'hero' ? 220 : 36}
      height={variant === 'hero' ? 220 : 36}
      decoding="async"
    />
  );
}
